import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLanguage } from '../hooks/useLanguage';
import './EmbeddedSection.css';

export default function EmbeddedSection() {
  const { t } = useLanguage();

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="embedded" id="embedded" data-aos="fade-up">
      <div className="embedded-content">
        <h2 className="section-heading" data-aos="fade-up">{t.embedded.title}</h2>
        <p className="section-lead embedded-intro" data-aos="fade-up" data-aos-delay="80">
          {t.embedded.intro}
        </p>
        <ul className="embedded-list">
          <li data-aos="fade-up" data-aos-delay="120">{t.embedded.b1}</li>
          <li data-aos="fade-up" data-aos-delay="160">{t.embedded.b2}</li>
          <li data-aos="fade-up" data-aos-delay="200">{t.embedded.b3}</li>
        </ul>
      </div>
    </section>
  );
}
